import { render, staticRenderFns } from "./CadastroToken.vue?vue&type=template&id=d1809ae4&scoped=true"
import script from "./CadastroToken.vue?vue&type=script&lang=ts"
export * from "./CadastroToken.vue?vue&type=script&lang=ts"
import style0 from "./CadastroToken.vue?vue&type=style&index=0&id=d1809ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1809ae4",
  null
  
)

export default component.exports